export default (sitemap: SitemapBuilder) =>
{
    sitemap.after('[[[Marketing]]]', [
        {
            name: '[[[Sklep]]]',
            short: '[[[Sklep]]]',
            icon: 'fa-light fa-cart-shopping',
            children: [
                {
                    name: '[[[Sprzedaż]]]',
                    header: true
                },
                {
                    name: '[[[Zamówienia]]]',
                    icon: 'fa-regular fa-cash-register',
                    route: 'store-orders',
                    namespace: 'Ideo.Core.ECommerce.Application.Cases.Sales.Orders.Permissions',
                    auth: { all: ['OrdersPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Szczegóły zamówienia]]]',
                            route: 'store-orders-edit',
                            auth: { all: ['OrdersPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Faktury]]]',
                    icon: 'fa-regular fa-file',
                    route: 'store-invoices',
                    namespace: 'Ideo.Core.ECommerce.Application.Cases.Sales.Orders.Permissions',
                    auth: { all: ['OrdersPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie faktury]]]',
                            route: 'store-invoices-add',
                            auth: { all: ['OrdersPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Szczegóły faktury]]]',
                            route: 'store-invoices-edit',
                            auth: { all: ['OrdersPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Reklamacje i zwroty]]]',
                    icon: 'fa-regular fa-rotate-left',
                    route: 'store-complaints',
                    namespace: 'Ideo.Core.ECommerce.Application.Cases.Sales.Complaints.Permissions',
                    auth: { all: ['ComplaintsPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Szczegóły zgłoszenia]]]',
                            route: 'store-complaints-edit',
                            auth: { all: ['ComplaintsPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Opinie produktowe]]]',
                    icon: 'fa-regular fa-comments',
                    route: 'store-ratings',
                    namespace: 'Ideo.Core.ECommerce.Application.Cases.Sales.Ratings.Permissions',
                    auth: { all: ['RatingsPremissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Szczegóły opinii]]]',
                            route: 'store-ratings-edit',
                            auth: { all: ['RatingsPremissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Cenniki]]]',
                    route: 'store-price-lists',
                    icon: 'fa-regular fa-table-list',
                    namespace: 'Ideo.Core.ECommerce.Application.Cases.Settings.PriceLists.Permissions',
                    auth: { all: ['PriceListsPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie cennika]]]',
                            route: 'store-price-lists-add',
                            auth: { all: ['PriceListsPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja cennika]]]',
                            route: 'store-price-lists-edit',
                            auth: { all: ['PriceListsPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Katalog]]]',
                    header: true
                },
                {
                    name: '[[[Produkty]]]',
                    route: 'store-products',
                    icon: 'fa-regular fa-box',
                    namespace: 'Ideo.Core.ECommerce.Application.Cases.Catalog.Products.Permissions',
                    auth: { all: ['ProductsPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie produktu]]]',
                            route: 'store-products-add',
                            auth: { all: ['ProductsPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja produktu]]]',
                            route: 'store-products-edit',
                            auth: { all: ['ProductsPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Kategorie]]]',
                    route: 'store-categories',
                    icon: 'far fa-folder-tree',
                    namespace: 'Ideo.Core.ECommerce.Application.Cases.Catalog.Categories.Permissions',
                    auth: { all: ['CategoriesPermissions@View'], any: [] }
                },
                {
                    name: '[[[Kolekcje]]]',
                    route: 'store-collections',
                    icon: 'far fa-rectangle-history',
                    namespace: 'Ideo.Core.ECommerce.Application.Cases.Catalog.Collections.Permissions',
                    auth: { all: ['CollectionsPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie kolekcji]]]',
                            route: 'store-collections-add',
                            auth: { all: ['CollectionsPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja kolekcji]]]',
                            route: 'store-collections-edit',
                            auth: { all: ['CollectionsPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Producenci]]]',
                    route: 'store-producers',
                    namespace: 'Ideo.Core.ECommerce.Application.Cases.Catalog.Producers.Permissions',
                    icon: 'fa-regular fa-industry',
                    auth: { all: ['ProducersPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie producenta]]]',
                            route: 'store-producers-add',
                            auth: { all: ['ProducersPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja producenta]]]',
                            route: 'store-producers-edit',
                            auth: { all: ['ProducersPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Etykiety]]]',
                    route: 'store-labels',
                    icon: 'fa-regular fa-tag',
                    namespace: 'Ideo.Core.ECommerce.Application.Cases.Catalog.Labels.Permissions',
                    auth: { all: ['LabelsPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie etykiety]]]',
                            route: 'store-labels-add',
                            auth: { all: ['LabelsPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja etykiety]]]',
                            route: 'store-labels-edit',
                            auth: { all: ['LabelsPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Grupy cech]]]',
                    route: 'store-properties-groups',
                    icon: 'fa-regular fa-folder-grid',
                    namespace: 'Ideo.Core.ECommerce.Application.Cases.Catalog.PropertiesGroups.Permissions',
                    auth: { all: ['PropertiesGroupsPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie grupy cech]]]',
                            route: 'store-properties-groups-add',
                            auth: { all: ['PropertiesGroupsPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja grupy cech]]]',
                            route: 'store-properties-groups-edit',
                            auth: { all: ['PropertiesGroupsPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Sortowanie grup cech]]]',
                            route: 'store-properties-groups-sort',
                            auth: { all: ['PropertiesGroupsPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Cechy]]]',
                    route: 'store-properties',
                    icon: 'fa-regular fa-grid-2',
                    namespace: 'Ideo.Core.ECommerce.Application.Cases.Catalog.Properties.Permissions',
                    auth: { all: ['PropertiesPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie cechy]]]',
                            route: 'store-properties-add',
                            auth: { all: ['PropertiesPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja cechy]]]',
                            route: 'store-properties-edit',
                            auth: { all: ['PropertiesPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Sortowanie cech]]]',
                            route: 'store-properties-sort',
                            auth: { all: ['PropertiesPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Sortowanie wartości]]]',
                            route: 'store-properties-values-sort',
                            auth: { all: ['PropertiesPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Konfiguracja]]]',
                    header: true
                },
                {
                    name: '[[[Sklepy]]]',
                    route: 'store-shops',
                    icon: 'far fa-warehouse',
                    namespace: 'Ideo.Core.ECommerce.Application.Cases.Settings.Shops.Permissions',
                    auth: { all: ['ShopsPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie sklepów]]]',
                            route: 'store-shops-add',
                            auth: { all: ['ShopsPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja sklepów]]]',
                            route: 'store-shops-edit',
                            auth: { all: ['ShopsPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Waluty]]]',
                    route: 'store-currencies',
                    icon: 'far fa-euro-sign',
                    namespace: 'Ideo.Core.ECommerce.Application.Cases.Settings.Currencies.Permissions',
                    auth: { all: ['CurrenciesPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie waluty]]]',
                            route: 'store-currencies-add',
                            auth: { all: ['CurrenciesPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja waluty]]]',
                            route: 'store-currencies-edit',
                            auth: { all: ['CurrenciesPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Podatki]]]',
                    route: 'store-taxations',
                    icon: 'far fa-wallet',
                    namespace: 'Ideo.Core.ECommerce.Application.Cases.Settings.Taxations.Permissions',
                    auth: { all: ['CurrenciesPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie stawki]]]',
                            route: 'store-taxations-add',
                            auth: { all: ['TaxationsPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja stawki]]]',
                            route: 'store-taxations-edit',
                            auth: { all: ['TaxationsPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Kraje]]]',
                    route: 'store-countries',
                    icon: 'far fa-flag',
                    namespace: 'Ideo.Core.ECommerce.Application.Cases.Settings.Countries.Permissions',
                    auth: { all: ['CountriesPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie kraju]]]',
                            route: 'store-countries-add',
                            auth: { all: ['CountriesPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja kraju]]]',
                            route: 'store-countries-edit',
                            auth: { all: ['CountriesPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Dostawy]]]',
                    route: 'store-carriers',
                    icon: 'far fa-truck',
                    namespace: 'Ideo.Core.ECommerce.Application.Cases.Settings.Carriers.Permissions',
                    auth: { all: ['CarriersPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie opcji dostawy]]]',
                            route: 'store-carriers-add',
                            auth: { all: ['CarriersPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja opcji dostawy]]]',
                            route: 'store-carriers-edit',
                            auth: { all: ['CarriersPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Płatności]]]',
                    route: 'store-payments',
                    icon: 'far fa-credit-card',
                    namespace: 'Ideo.Core.ECommerce.Application.Cases.Settings.Payments.Permissions',
                    auth: { all: ['PaymentsPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie opcji płatności]]]',
                            route: 'store-payments-add',
                            auth: { all: ['PaymentsPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja opcji płatności]]]',
                            route: 'store-payments-edit',
                            auth: { all: ['PaymentsPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Kalendarz]]]',
                    route: 'store-calendar-entries',
                    icon: 'far fa-calendar-days',
                    namespace: 'Ideo.Core.ECommerce.Application.Cases.Settings.CalendarEntries.Permissions',
                    auth: { all: ['CalendarEntriesPermisions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie wpisu do kalendarza]]]',
                            route: 'store-calendar-entries-add',
                            auth: { all: ['CalendarEntriesPermisions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja wpisu do kalendarza]]]',
                            route: 'store-calendar-entries-edit',
                            auth: { all: ['CalendarEntriesPermisions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Reklamacje]]]',
                    route: 'store-complaints-settings',
                    icon: 'fa-regular fa-rotate-left',
                    namespace: 'Ideo.Core.ECommerce.Application.Cases.Settings.Complaints.Permissions',
                    auth: { all: ['ComplaintsPermissions@View'], any: [] }
                },
                {
                    name: '[[[Opinie]]]',
                    route: 'store-ratings-settings',
                    icon: 'fa-regular fa-comments',
                    namespace: 'Ideo.Core.ECommerce.Application.Cases.Sales.Ratings.Permissions',
                    auth: { all: ['RatingsPermissions@View'], any: [] }
                }
            ]
        }
    ]);
};
